<app-loading />
<router-outlet />
